<template>
  <div>
    <div class="tab_con m_flex_box flex_vb">
      <span :class="tab === 0 ? 'active' : ''" @click="changeTab(0)"
        >全部商品</span
      >
      <span :class="tab === 1 ? 'active' : ''" @click="changeTab(1)">好物</span>
      <span :class="tab === 2 ? 'active' : ''" @click="changeTab(2)">卡券</span>
    </div>
    <div class="integral_gift">
      <div class="integral_gift_flex">
        <div>
          <div><img src="" alt="" /></div>
          <div class="gift_flex_2">嘻嘻嘻哈哈</div>
          <div class="gift_flex_3">899积分</div>
        </div>
        <div>
          <div><img src="" alt="" /></div>
          <div class="gift_flex_2">嘻嘻嘻哈哈</div>
          <div class="gift_flex_3">899积分</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tab: 0,
    };
  },
  methods: {
    changeTab(num) {
      this.tab = num;
    },
  },
};
</script>
<style lang="less" scoped>
.tab_con {
  height: 1rem;
  background-color: #fff;
  display: flex;
  z-index: 9;
  span {
    flex: 1;
    font-weight: 800;
    font-size: 0.3rem;
    margin: 0.3rem;
    position: relative;
    text-align: center;
  }
  .active {
    color: #3072f5;
    font-size: 0.3rem;
    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      // margin-left: -0.2rem;
      transform: translateX(-50%);
      background-color: #3072f5;
      width: 0.7rem;
      height: 0.04rem;
    }
  }
}
.integral_gift {
  padding: 0.2rem 0.4rem;
  .integral_gift_flex {
    display: flex;
    justify-content: space-between;
    & > div {
      margin-top: 0.2rem;
      flex: 0 1 45%;
      border-radius: 5%;
      box-shadow: 0 0 5px rgba(207, 207, 207, 0.5);
      .gift_flex_2 {
        text-align: center;
        padding: 0.3rem 0.2rem;
        overflow: hidden;
        font-size: 0.3rem;
      }
      .gift_flex_3 {
        font-size: 0.3rem;
        padding: 0.5rem 0 0.5rem 0.3rem;
        color: #ff0000;
      }
    }
  }
}
</style>